




  import { Component, Prop, Vue } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import MobileMenu from './OneNewMobileMenuTypes'
  const Layout = namespace('layout')
  const auth = namespace('auth')

  @Component({
    components: {
      OneNewMobileMenu: () => import('~/components/molecules/menus/OneNewMobileMenu.vue'),
    },
  })
  export default class MobileAccountMenuWrapper extends Vue {
    @Layout.Mutation('TOGGLE_ACCOUNT_MENU') toggleMenuAccount: any
    @auth.State rol: any

    @Prop({
      type: Boolean,
    })
    isActiveMenu?: boolean

    get menuModel(): MobileMenu.MobileMenuModel {
      const children = [
        {
          name: this.$t('account_sidebar.account_information') as string,
          testId: 'account:menu:account-information:button',
          route: { name: 'account' },
        },
        {
          name: this.$t('account_sidebar.billing') as string,
          testId: 'account:menu:billing:button',
          route: { name: 'account-billing' },
        },
        {
          name: this.$t('account_sidebar.addresses') as string,
          testId: 'account:menu:addresses:button',
          route: { name: 'account-addresses' },
        },
        {
          permission: ['APP_USERS', 'APP_VIEW_ROLES'],
          name: this.$t('account_sidebar.roles') as string,
          testId: 'account:menu:roles:button',
          route: { name: 'account-roles' },
        },
        {
          permission: ['APP_USERS', 'APP_VIEW_USERS'],
          name: this.$t('account_sidebar.users') as string,
          testId: 'account:menu:users:button',
          route: { name: 'account-users' },
        },
        {
          name: this.$t('account_sidebar.agreements') as string,
          testId: 'account:menu:agreements:button',
          route: { name: 'account-agreements' },
        },
        {
          name: this.$t('account_sidebar.orders_history') as string,
          testId: 'account:menu:orders-history:button',
          route: { name: 'account-orders-online' },
        },
        {
          permission: ['APP_VIEW_INVOICES'],
          name: this.$utils.isB2B
            ? this.$t('account_sidebar.invoices_goods_issued_notes') as string
            : this.$t('account_sidebar.invoices') as string,
          testId: `account:menu:${this.$utils.isB2B ? 'invoices-goods-issued_notes' : 'invoices'}:button`,
          route: { name: 'account-invoices-goods-issued-notes-invoices' },
        },
        {
          name: this.$t('account_sidebar.complains') as string,
          testId: 'account:menu:complains:button',
          route: { name: 'account-complains' },
        },

        {
          name: this.$t('account_sidebar.shopping_list') as string,
          testId: 'account:menu:shopping-list:button',
          route: { name: 'wishlist' },
        },
        {
          name: this.$t('account_sidebar.rfqs_offers') as string,
          testId: 'account:menu:rfqs-offers:button',
          route: { name: 'account-rfqs-offers-rfqs' },
        },
        {
          permission: ['APP_AUTHORIZATION_CART'],
          name: this.$t('account_sidebar.order_authorization') as string,
          testId: 'account:menu:order-authorization:button',
          route: { name: 'account-order-authorization' },
        },
        {
          name: this.$t('account_sidebar.contact') as string,
          testId: 'account:menu:contact:button',
          route: { name: 'account-contact' },
        },
        {
          name: this.$t('header.logout') as string,
          testId: 'account:menu:logout:button',
          customClickAction: (vm: Vue) => {
            vm.$emit('close')
            this.$auth.logout()
            this.$router.push({
              path: this.$tenantConfig.isCatalogOpened
                ? `${this.localePath('/')}`
                : `${this.localePath('login')}`,
            })
          },
        },
      ]
      return {
        name: this.$t('account_sidebar.title') as string,
        children: children.filter((el: MobileMenu.RouteMenuItemWithPermissions) => {
          if (el.permission) {
            return this.$auth.hasPermissions(el?.permission, true)
          } else {
            return true
          }
        }),
      }
    }
  }
